import gql from 'graphql-tag';

export const UPDATE_DEAL_CLOSURE = gql`
  mutation UpdateDealClosure($input: UpdateDealClosureInput!) {
    bpf {
      result: updateDealClosure(input: $input) {
        error
        success
        entity {
          id
          parentId
          parentType
          closedDateTime
          createdDateTime
          updatedDateTime
        }
      }
    }
  }
`;
